import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import theme from '../../theme';

const SuccessToast = ({ message }) => {
  return (
    <ThemeProvider theme={theme}>
      <Alert severity="success" variant="filled">
        {message}
      </Alert>
    </ThemeProvider>
  );
};

SuccessToast.propTypes = {
  message: PropTypes.string.isRequired,

};

export default SuccessToast;
